import { type SVGProps } from 'react'
const Joomla = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='276.921 100.257 75 74.9'
        {...props}
    >
        <path
            fill='#7ac143'
            d='m290.32 137.957-1.4-1.4c-4.5-4.5-5.8-10.8-4.2-16.5-4.5-1-7.8-5-7.8-9.8 0-5.5 4.5-10 10-10 5 0 9.1 3.6 9.9 8.4 5.4-1.3 11.3.2 15.5 4.4l.6.6-7.4 7.4-.6-.6c-2.4-2.4-6.3-2.4-8.7 0s-2.4 6.3 0 8.7l16.6 16.6-7.4 7.4-7.8-7.8z'
        />
        <path
            fill='#f9a541'
            d='m298.62 129.757 16.6-16.6c4.4-4.4 10.8-5.8 16.4-4.2.7-4.9 4.9-8.6 9.9-8.6 5.5 0 10 4.5 10 10 0 5.1-3.8 9.3-8.7 9.9 1.6 5.6.2 11.9-4.2 16.3l-.6.6-7.2-7.4.6-.6c2.4-2.4 2.4-6.3 0-8.7s-6.3-2.4-8.7 0l-16.6 16.6z'
        />
        <path
            fill='#f44321'
            d='M331.92 167.057c-5.7 1.7-12.1.4-16.6-4.1l-.6-.6 7.4-7.4.6.6c2.4 2.4 6.3 2.4 8.7 0s2.4-6.3 0-8.7l-16.6-16.6 7.4-7.4 16.7 16.7c4.2 4.2 5.7 10.2 4.4 15.7 4.9.7 8.6 4.9 8.6 9.9 0 5.5-4.5 10-10 10-5-.1-9.1-3.6-10-8.1z'
        />
        <path
            fill='#5091cd'
            d='m329.02 146.257-16.6 16.6c-4.3 4.3-10.3 5.7-15.7 4.4-1 4.5-5 7.8-9.8 7.8-5.5 0-10-4.5-10-10 0-4.7 3.3-8.7 7.7-9.7-1.4-5.6 0-11.6 4.3-15.9l.6-.6 7.4 7.4-.6.6c-2.4 2.4-2.4 6.3 0 8.7s6.3 2.4 8.7 0l16.6-16.6z'
        />
    </svg>
)
export default Joomla
